/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Status } from './Status';
// @ts-ignore
import {
// @ts-ignore
    StatusFromJSON,
// @ts-ignore
    StatusFromJSONTyped,
// @ts-ignore
    StatusToJSON,
} from './Status';

/**
 * 
 * @export
 * @interface OrganizationUpdateRequest
 */
export interface OrganizationUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganizationUpdateRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUpdateRequest
     */
    name: string;
    /**
     * 
     * @type {Status}
     * @memberof OrganizationUpdateRequest
     */
    status: Status;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUpdateRequest
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUpdateRequest
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUpdateRequest
     */
    currencyCode: string;
}

/**
 * Check if a given object implements the OrganizationUpdateRequest interface.
 */
// @ts-ignore
export function instanceOfOrganizationUpdateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "countryCode" in value;
    isInstance = isInstance && "timezone" in value;
    isInstance = isInstance && "currencyCode" in value;

    return isInstance;
}

// @ts-ignore
export function OrganizationUpdateRequestFromJSON(json: any): OrganizationUpdateRequest {
    return OrganizationUpdateRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function OrganizationUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationUpdateRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'status': StatusFromJSON(json['status']),
        'countryCode': json['country_code'],
        'timezone': json['timezone'],
        'currencyCode': json['currency_code'],
    };
}

// @ts-ignore
export function OrganizationUpdateRequestToJSON(value?: OrganizationUpdateRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'status': StatusToJSON(value.status),
        'country_code': value.countryCode,
        'timezone': value.timezone,
        'currency_code': value.currencyCode,
    };
}

